import { render, staticRenderFns } from "./HousingListItems.vue?vue&type=template&id=abfb03d4&scoped=true"
import script from "./HousingListItems.vue?vue&type=script&lang=js"
export * from "./HousingListItems.vue?vue&type=script&lang=js"
import style0 from "./HousingListItems.vue?vue&type=style&index=0&id=abfb03d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfb03d4",
  null
  
)

export default component.exports